/**
 * Generated from LightsOutElmoLivingRoomLayout.fla
 */
export function LightsOutElmoLivingRoomLayout(this: ILightsOutElmoLivingRoomLayout) {
	const bg = this.bg;
	LightsOutElmoLivingRoomLayout_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const piano = this.piano;
	LightsOutElmoLivingRoomLayout_piano.call(this.piano);
	piano.x = 1271.75;
	piano.y = 494;
	piano.width = 362.50;
	piano.height = 299.00;
	if (piano.onLayout) piano.onLayout();
	const ceilingLight = this.ceilingLight;
	LightsOutElmoLivingRoomLayout_ceilingLight.call(this.ceilingLight);
	ceilingLight.x = 634.5;
	ceilingLight.y = 73;
	ceilingLight.width = 106.00;
	ceilingLight.height = 146.00;
	if (ceilingLight.onLayout) ceilingLight.onLayout();
	const globe = this.globe;
	LightsOutElmoLivingRoomLayout_globe.call(this.globe);
	globe.x = 1272.75;
	globe.y = 295.25;
	globe.width = 81.50;
	globe.height = 105.50;
	if (globe.onLayout) globe.onLayout();
	const guitar = this.guitar;
	LightsOutElmoLivingRoomLayout_guitar.call(this.guitar);
	guitar.x = 635.5;
	guitar.y = 373.75;
	guitar.width = 104.00;
	guitar.height = 221.50;
	if (guitar.onLayout) guitar.onLayout();
	const lamp = this.lamp;
	LightsOutElmoLivingRoomLayout_lamp.call(this.lamp);
	lamp.x = 508.5;
	lamp.y = 524;
	lamp.width = 84.00;
	lamp.height = 119.50;
	if (lamp.onLayout) lamp.onLayout();
	const lightSwitch = this.lightSwitch;
	LightsOutElmoLivingRoomLayout_lightSwitch.call(this.lightSwitch);
	lightSwitch.x = 389;
	lightSwitch.y = 352.25;
	lightSwitch.width = 29.00;
	lightSwitch.height = 49.50;
	if (lightSwitch.onLayout) lightSwitch.onLayout();
	const pianoSeat = this.pianoSeat;
	LightsOutElmoLivingRoomLayout_pianoSeat.call(this.pianoSeat);
	pianoSeat.x = 1281.75;
	pianoSeat.y = 614;
	pianoSeat.width = 143.50;
	pianoSeat.height = 115.00;
	if (pianoSeat.onLayout) pianoSeat.onLayout();
	const radio = this.radio;
	LightsOutElmoLivingRoomLayout_radio.call(this.radio);
	radio.x = 1165.75;
	radio.y = 319.5;
	radio.width = 83.50;
	radio.height = 61.00;
	if (radio.onLayout) radio.onLayout();
	const robot = this.robot;
	LightsOutElmoLivingRoomLayout_robot.call(this.robot);
	robot.x = 1046;
	robot.y = 662;
	robot.width = 73.00;
	robot.height = 79.00;
	if (robot.onLayout) robot.onLayout();
	const tablet = this.tablet;
	LightsOutElmoLivingRoomLayout_tablet.call(this.tablet);
	tablet.x = 367.25;
	tablet.y = 562.5;
	tablet.width = 62.50;
	tablet.height = 71.00;
	if (tablet.onLayout) tablet.onLayout();
	const tv = this.tv;
	LightsOutElmoLivingRoomLayout_tv.call(this.tv);
	tv.x = 894;
	tv.y = 487.5;
	tv.width = 278.00;
	tv.height = 177.00;
	if (tv.onLayout) tv.onLayout();
	const homeButton = this.homeButton;
	LightsOutElmoLivingRoomLayout_homeButton.call(this.homeButton);
	homeButton.x = 428;
	homeButton.y = 164.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	const ceilinglightGlow = this.ceilinglightGlow;
	LightsOutElmoLivingRoomLayout_ceilinglightGlow.call(this.ceilinglightGlow);
	ceilinglightGlow.x = 634.7;
	ceilinglightGlow.y = 136.35;
	ceilinglightGlow.width = 127.00;
	ceilinglightGlow.height = 41.50;
	if (ceilinglightGlow.onLayout) ceilinglightGlow.onLayout();
	const lampGlow = this.lampGlow;
	LightsOutElmoLivingRoomLayout_lampGlow.call(this.lampGlow);
	lampGlow.x = 508.6;
	lampGlow.y = 438.35;
	lampGlow.width = 100.00;
	lampGlow.height = 74.50;
	if (lampGlow.onLayout) lampGlow.onLayout();
	const elmo = this.elmo;
	LightsOutElmoLivingRoomLayout_elmo.call(this.elmo);
	elmo.x = 1183.25;
	elmo.y = 744;
	elmo.width = 221.00;
	elmo.height = 320.00;
	if (elmo.onLayout) elmo.onLayout();
	return this;
}
function LightsOutElmoLivingRoomLayout_bg(this: ILightsOutElmoLivingRoomLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("lightsout-livingroom-background.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_piano(this: ILightsOutElmoLivingRoomLayout_piano) {
	if (this.setLayoutTexture) this.setLayoutTexture("piano.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_ceilingLight(this: ILightsOutElmoLivingRoomLayout_ceilingLight) {
	if (this.setLayoutTexture) this.setLayoutTexture("ceilinglight.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_globe(this: ILightsOutElmoLivingRoomLayout_globe) {
	if (this.setLayoutTexture) this.setLayoutTexture("globe.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_guitar(this: ILightsOutElmoLivingRoomLayout_guitar) {
	if (this.setLayoutTexture) this.setLayoutTexture("Guitar.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_lamp(this: ILightsOutElmoLivingRoomLayout_lamp) {
	if (this.setLayoutTexture) this.setLayoutTexture("lamp.png", 0.500, 1.000);
	return this;
}
function LightsOutElmoLivingRoomLayout_lightSwitch(this: ILightsOutElmoLivingRoomLayout_lightSwitch) {
	if (this.setLayoutTexture) this.setLayoutTexture("LightSwitch.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_pianoSeat(this: ILightsOutElmoLivingRoomLayout_pianoSeat) {
	if (this.setLayoutTexture) this.setLayoutTexture("pianoseat.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_radio(this: ILightsOutElmoLivingRoomLayout_radio) {
	if (this.setLayoutTexture) this.setLayoutTexture("Radio.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_robot(this: ILightsOutElmoLivingRoomLayout_robot) {
	if (this.setLayoutTexture) this.setLayoutTexture("Robot.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_tablet(this: ILightsOutElmoLivingRoomLayout_tablet) {
	if (this.setLayoutTexture) this.setLayoutTexture("tablet.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_tv(this: ILightsOutElmoLivingRoomLayout_tv) {
	if (this.setLayoutTexture) this.setLayoutTexture("tv.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_homeButton(this: ILightsOutElmoLivingRoomLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_ceilinglightGlow(this: ILightsOutElmoLivingRoomLayout_ceilinglightGlow) {
	if (this.setLayoutTexture) this.setLayoutTexture("ceilinglight-on-glow.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_lampGlow(this: ILightsOutElmoLivingRoomLayout_lampGlow) {
	if (this.setLayoutTexture) this.setLayoutTexture("lamp-on-glow.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoLivingRoomLayout_elmo(this: ILightsOutElmoLivingRoomLayout_elmo) {
	if (this.setLayoutTexture) this.setLayoutTexture("Elmo.png", 0.502, 1.000);
	return this;
}
interface ILightsOutElmoLivingRoomLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ILightsOutElmoLivingRoomLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ILightsOutElmoLivingRoomLayoutSprite extends ILightsOutElmoLivingRoomLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ILightsOutElmoLivingRoomLayoutText extends ILightsOutElmoLivingRoomLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ILightsOutElmoLivingRoomLayoutPolygon extends Array<number> {
}
interface ILightsOutElmoLivingRoomLayout {
	readonly bg: ILightsOutElmoLivingRoomLayout_bg;
	readonly piano: ILightsOutElmoLivingRoomLayout_piano;
	readonly ceilingLight: ILightsOutElmoLivingRoomLayout_ceilingLight;
	readonly globe: ILightsOutElmoLivingRoomLayout_globe;
	readonly guitar: ILightsOutElmoLivingRoomLayout_guitar;
	readonly lamp: ILightsOutElmoLivingRoomLayout_lamp;
	readonly lightSwitch: ILightsOutElmoLivingRoomLayout_lightSwitch;
	readonly pianoSeat: ILightsOutElmoLivingRoomLayout_pianoSeat;
	readonly radio: ILightsOutElmoLivingRoomLayout_radio;
	readonly robot: ILightsOutElmoLivingRoomLayout_robot;
	readonly tablet: ILightsOutElmoLivingRoomLayout_tablet;
	readonly tv: ILightsOutElmoLivingRoomLayout_tv;
	readonly homeButton: ILightsOutElmoLivingRoomLayout_homeButton;
	readonly ceilinglightGlow: ILightsOutElmoLivingRoomLayout_ceilinglightGlow;
	readonly lampGlow: ILightsOutElmoLivingRoomLayout_lampGlow;
	readonly elmo: ILightsOutElmoLivingRoomLayout_elmo;
}
interface ILightsOutElmoLivingRoomLayout_bg extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_piano extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_ceilingLight extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_globe extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_guitar extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_lamp extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_lightSwitch extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_pianoSeat extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_radio extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_robot extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_tablet extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_tv extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_homeButton extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_ceilinglightGlow extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_lampGlow extends ILightsOutElmoLivingRoomLayoutSprite {
}
interface ILightsOutElmoLivingRoomLayout_elmo extends ILightsOutElmoLivingRoomLayoutSprite {
}
